import { render } from "./page3.vue?vue&type=template&id=d073095c&scoped=true"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"

import "./page3.vue?vue&type=style&index=0&id=d073095c&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d073095c"]])

export default __exports__